import mergeDeep from '@tinkoff/utils/object/mergeDeep';
import { g } from '@tinkoff/statist-page-data';
export var clientInitOptionsResolver = function (options) {
    if (g._statistClientInitOptions) {
        return mergeDeep(options, g._statistClientInitOptions);
    }
    return options;
};
//# sourceMappingURL=clientInitOptions.js.map